// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tu8o","controls":"styles_controls__1n9V0","charLimit":"styles_charLimit__2DtQW","input":"styles_input__1cNQz","send":"styles_send__2WDwO"};